<template>

<HFull2


title="Managed Investment Solutions"
    subtitle=
      "Augment business ability . Energize track record with efficiency and speed. "

    :img="Main"
    class="text-blue"
    height="95vh"




/>

<DescriptionCard
        flat
        title="Our Solutions"
        description="ONICET Augments Consulting with Managed Solutions for enterprise enabling companies to extend operations and manage development in all-in-one platform managed by consultants experienced in increasing ROI and maximizng business value
"
        color="transparent"
        cl="mt-0 pa-0 ma-2 text-h3 font-weight-light text-grey"
      />





  <Product :productsData="products" :col="3"/>











  
  <L2
  title="How do we create impact?"
  description="kjhgvcfghjkljhbvcvbnmk"
  
  
  />

  <Cta2 

  title="Book a meeting with our Consultants to explore how can we help"
  btext="Connect"
  link="/Connect"

  
  
  
  />
</template>

<script setup lang="js">
import Hero from "../components/Hero.vue";
import HFull from "../components/HFull.vue";
import HFull2 from "../components/HFull2.vue";

import Left from "../web/Left.vue";

// import Left from "../components/Left.vue";
import LeftSwapped from "../components/LeftSwapped.vue";




import Right from "../components/R.vue";
import Cards from "../components/Cards.vue";
import HCard from "../components/HCard.vue";
import Hero1 from "../components/Hero1.vue";

import CardsAva from "../components/CardsAva.vue";
import Banner from "../components/Banner.vue";
import Footer from "../components/Footer.vue";
import DescriptionCard from "../components/DescriptionCard.vue";
import Overview from "../components/Overview.vue";
import Right2 from "../web/Right.vue";
import Left2 from "../web/Left.vue";



//images
import O from "../assets2/2.jpg";
import Cloud from "../assets2/cloud.svg";
import Banner2 from "../components/Banner2.vue";
import Green from "../assets/Green.svg";
import ONICET from "../assets/ONICET.svg";
import ONICETnew from "../assets/ONICETnew.svg";
import Blue from "../assets2/Blue.png";
import Main from "../assets/Main.png";
import Connect2 from "../assets/Connect2.png";
import Lego from "../assets/Lego.svg";
import ONB from "../assets/ONB.svg";

import add from "../_icons/add--document.svg";
import colab from "../_icons/collaboration.svg";
import launch from "../_icons/launch.svg";
import group from "../_icons/group.svg";
import cont from "../_icons/continuous.svg";
import CenterH from "../components/CenterH.vue";  



import P1 from "../assets2/P1.svg";
import WB from "../assets2/WB.svg";
import OKR from "../assets2/OKR.svg";
import Learning from "../assets2/Learning.svg";
import XM from "../assets2/XM.svg";



import Landing from "../assets2/Landing.png";
import Heatmap from "../assets2/Heatmap.png";
import trees from "../assets2/trees.png";
import Cta2 from "../components/Cta2.vue";  



import { ref } from "vue";


import Product from "../web/Product.vue";
// import { products }  from "../data.js";


const cards = [
  {
    href: '/Assessment',
    title: "Online Diagnosis",
    subtitle: "Online Assessment",
    description:"Lorem, ipsum dolor sit amet consectetur adipisicing elit. Repellat veniam nam incidunt?",
    img: P1,
    titleclass: "text-h4",
    desclass: "text-h6 text-grey",
    // color: "#F1F1F1",

  },
  {
    href: '/Workbook',
    title: "AI Workbook",
    subtitle: "Online Assessment",
    description:"Lorem, ipsum dolor sit amet consectetur adipisicing elit. Repellat veniam nam incidunt?",
    img: WB,
    titleclass: "text-h4",
    desclass: "text-h6 text-grey",

    // color: "#F1F1F1",

  },
  {
    href: '/Strategy',

    title: "Strategic Planning",
    subtitle: "Online Assessment",
    description:"Lorem, ipsum dolor sit amet consectetur adipisicing elit. Repellat veniam nam incidunt?",
    img: OKR,
    titleclass: "text-h4",
    desclass: "text-h6 text-grey",
    // color: "#F1F1F1",

  },
  {
    href: '/XM',
    title: "Impact XM",
    subtitle: "Online Assessment",
    description:"Lorem, ipsum dolor sit amet consectetur adipisicing elit. Repellat veniam nam incidunt?",
    img: Learning,
    titleclass: "text-h4",
    desclass: "text-h6 text-grey",
    // color: "#F1F1F1",

  },
  {
    href: '/Insights',
    title: "Auto Insights",
    subtitle: "Online Assessment",
    description:"Lorem, ipsum dolor sit amet consectetur adipisicing elit. Repellat veniam nam incidunt?",
    img: XM,
    titleclass: "text-h4",
    desclass: "text-h6 text-grey",
    // color: "#F1F1F1",

  },
  {
    title: "Auto Insights",
    subtitle: "Online Assessment",
    description:"Lorem, ipsum dolor sit amet consectetur adipisicing elit. Repellat veniam nam incidunt?",
    img: XM,
    titleclass: "text-h4",
    desclass: "text-h6 text-grey",
    // color: "#F1F1F1",

  },
];





const Steps = [
  {
    title: "1. Onboard",
    description: "OC-Consultant Assigned",
    subtitle: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Autem at eum laborum ad placeat quas officia voluptatem, ",
    img: P1,
    imgh:"150",
    olor: "green-lighten-4",




  },
  {
    title: "2. Assess",
    description: "Explore results ",
    subtitle: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Autem at eum laborum ad placeat quas officia voluptatem, ",
    img: WB,
    imgh:"150",
    olor: "green-lighten-4",





  },
  {
    title: "3. Diagnose ",
    description: "Collaborate",
    subtitle: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Autem at eum laborum ad placeat quas officia voluptatem, ",
    olor: "green-lighten-4",
    img: OKR,
    imgh:"150",




  },
  {
    title: "4. Ideate",
    description: "Plan",
    subtitle: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Autem at eum laborum ad placeat quas officia voluptatem, ",
    olor: "green-lighten-4",
    img: Learning,
    imgh:"150",



  },
  {
    title: "5. Deploy ",
    description: "Set Goals and Manage Results",
    subtitle: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Autem at eum laborum ad placeat quas officia voluptatem, ",
    olor: "green-lighten-4",
    img: XM,
    imgh:"100",




  },
 
 

];


const products = [
  {
    title: 'Optimize',
    subtitle: 'ONICET',
    description: 'Streamline your strategy, resources, and execution to unlock efficiency, reduce waste, and maximize return on investment.',
    link: 'Optimize',
    img: P1,
  },
  {
    title: 'Build',
    subtitle: 'ONICET',
    description: 'Turn ideas into scalable ventures with end-to-end support in product development, design, and market readiness.',
    link: 'Build',
    img: WB,
  },
  {
    title: 'Manage',
    subtitle: 'ONICET',
    description: 'Deploy agile systems, OKRs, and performance oversight to manage teams, projects, and outcomes effectively.',
    link: 'Manage',
    img: OKR,
  },
  {
    title: 'Operate',
    subtitle: 'ONICET',
    description: 'Run your business with plug-and-play operational units that provide stability, adaptability, and continuous delivery.',
    link: 'Operate',
    img: Learning,
  }
];










</script>

<style scoped>
.home {
  background-color: #e8e7e7;
}
</style>
